<template>
    <v-toolbar dense app color="primary">
        <v-img src="/piguet.svg" :max-width="150" />
        <v-toolbar-title color="info" class="white--text">
            <span>aPad</span>
        </v-toolbar-title>
        <v-spacer />
        <pad-visa-selector />
        <v-spacer />
        <v-btn icon flat dark :color="lotsNotesColor" @click="lotsNotes">
            <v-icon>announcement</v-icon>
        </v-btn>
        <v-btn icon flat dark color="secondary" @click="goCurrent">
            <v-icon>my_location</v-icon>
        </v-btn>
        <v-btn icon flat dark @click="drawer = true">
            <v-icon>more_vert</v-icon>
        </v-btn>
        <template #extension>
            <v-layout class="grey lighten-3 px-4 pt-1 pb-3">
                <v-flex class="mr-4">
                    <pad-sale-selector />
                </v-flex>
                <v-flex class="ml-4">
                    <pad-vacation-selector />
                </v-flex>
            </v-layout>
        </template>
    </v-toolbar>
</template>

<script>
import PadSaleSelector from '@/components/PadSaleSelector'
import PadVacationSelector from '@/components/PadVacationSelector'
import PadVisaSelector from '@/components/PadVisaSelector'

export default {
    name: 'pad-top-toolbar',
    components: { PadSaleSelector, PadVacationSelector, PadVisaSelector },
    props: {
        value: { type: Boolean }
    },
    computed: {
        drawer: {
            get() {
                return this.value
            },
            set(v) {
                this.$emit('input', v)
            }
        },
        lotsNotesColor() {
            return this.$store.getters['lot/notes'] ? 'yellow' : 'secondary'
        }
    },
    methods: {
        goCurrent() {
            this.$store.commit('lot/switchCurrent')
        },
        lotsNotes() {
            this.$store.commit('lot/switchNotes')
        }
    }
}
</script>

<style lang="stylus">
.v-toolbar__extension
    padding: 0;
    height: auto !important;

</style>
